export const TIMEOUT_VIEW = 2000;
